import { render, staticRenderFns } from "./ReporteReferenciasComponent.vue?vue&type=template&id=50b58a5a&scoped=true&"
import script from "./ReporteReferenciasComponent.vue?vue&type=script&lang=js&"
export * from "./ReporteReferenciasComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReporteReferenciasComponent.vue?vue&type=style&index=0&id=50b58a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b58a5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
